import React from 'react';
import PropTypes from 'prop-types';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';
import LazyImage from '../../../HOC/lazyImage';

const GalleryItem = ({
  id,
  url,
  handleDelete,
  handleRotateRight,
  handleRotateLeft
}) => {
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id });

  const style = isDragging
    ? {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: 0.7,
        zIndex: 1
      }
    : {
        transform: CSS.Transform.toString(transform)
      };

  return (
    <div
      className="item-modal__photo-card"
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <div
        tabIndex={0}
        role="button"
        onClick={handleDelete}
        onKeyPress={handleDelete}
        className="item-modal__photo-icon item-modal__photo-icon--delete"
      />
      <div
        tabIndex={0}
        role="button"
        onClick={handleRotateRight}
        onKeyPress={handleRotateRight}
        className="item-modal__photo-icon item-modal__photo-icon--rotate-right"
      />
      <div
        tabIndex={0}
        role="button"
        onClick={handleRotateLeft}
        onKeyPress={handleRotateLeft}
        className="item-modal__photo-icon item-modal__photo-icon--rotate-left"
      />
      <LazyImage className="item-modal__photo" src={url} />
    </div>
  );
};

GalleryItem.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  handleDelete: PropTypes.func,
  handleRotateLeft: PropTypes.func,
  handleRotateRight: PropTypes.func
};

export default GalleryItem;
